import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import SmoothScroll from "./components/site/SmoothScroll";
import Layout from "./components/site/Layout";import Home from "./pages/Home";
import About from "./pages/About";
import DomesticCleaning from "./pages/DomesticCleaning";
import MobileCarValeting from "./pages/MobileCarValeting";
import Prices from "./pages/Prices";
import Gallery from "./pages/Gallery";
import BookOnline from "./pages/BookOnline";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <SmoothScroll>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/domestic-cleaning" element={<DomesticCleaning />} />
                <Route path="/mobile-car-valeting" element={<MobileCarValeting />} />
                <Route path="/prices" element={<Prices />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/book" element={<BookOnline />} />
                <Route path="/contact" element={<Contact />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </SmoothScroll>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
